module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-65.746787f6.gif";